import { RolePageShell } from './RolePageShell.tsx';

interface OperatorPageShellProps {
  children: React.ReactNode;
  maxWidth?: string;
  padTop?: string;
  flexMain?: boolean;
}

/** Layout wrapper for all operator pages. Non-operators see a forbidden message. */
export function OperatorPageShell({ children, maxWidth, padTop, flexMain }: OperatorPageShellProps) {
  return (
    <RolePageShell role="operator" maxWidth={maxWidth} padTop={padTop} flexMain={flexMain}>
      {children}
    </RolePageShell>
  );
}
